// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../engines/components/BaseComponent";
import BaseStateSprite from "../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { SettleLawsuitKind } from "../../../define/SettleLawsuitKind";
import ModelDialogLayer from "../../../gameCommon/basic/ModelDialogLayer";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitItemNode extends BaseComponent {

	@property({ type: BaseStateSprite, displayName:'' })
	sprBg: BaseStateSprite = null;

	@property({ type: cc.Label, displayName:'' })
	lbReputation: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	lbMoney: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	lbName: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	starLayout: cc.Node = null;


    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initUI();
    }

    initUI() {
        let data = this._carryData;
        let star = data.star;

        this.sprBg.setFill(data.bHaveGood);

        this.lbReputation.string = '+' + data.exp;
        this.lbMoney.string = '+' + data.gold;
        this.lbName.string = data.name;

        this.starLayout.children.forEach((v, i)=> {
            v.getChildByName('starF').active = (i>=star ? false : true);
        });
    }

    onClickAd() {
        utilsModel.loadAndShowVideoAdTrans(()=>{
            let gameManager = NormalGameManager._instance;
            let gameData = gameManager.getGameData();
            gameData.todaySettleLawsuitUseCount = 0;
            gameManager.writeGameData();
            this._carryData.parent.refreshUseCount();
            this.enterGame();
            // this.refreshUseCount();
        },()=>{

        },null,"断案观看广告增加次数")
    }

    onClickEnter() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let maxCount = SettleLawsuitKind.GeneralValue.MAX_USE_COUNT;
        if (gameData.todaySettleLawsuitUseCount >= maxCount) {
            ModelDialogLayer.show('今日断案次数已达上限', null, ()=> {
               this.onClickAd();
            }
            , '我要加班'
            , null
            , true
            );
            return;
        }
       this.enterGame();
    }

    enterGame() {
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        gameData.todaySettleLawsuitUseCount++;
        gameManager.writeGameData();
        this._carryData.parent.refreshUseCount();
        
        let caseId = this._carryData.caseId;
        let prefabFile = this._carryData.prefab;
        utilsView.openPopupLayerTwo(
            prefabFile
            , null
            , {id: caseId}
        );
    }

    // update (dt) {}
}
